import { render } from "./Grant.vue?vue&type=template&id=319d8761&scoped=true"
import script from "./Grant.vue?vue&type=script&lang=js"
export * from "./Grant.vue?vue&type=script&lang=js"

import "./Grant.vue?vue&type=style&index=0&id=319d8761&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319d8761"]])

export default __exports__